/**
 * Canonical YesFi brand mark geometry — sourced from sayfi-frontend
 * `src/shared/ui/yesfiBrandMarkPaths.ts`.
 *
 * 关联文档文件：sayfi-frontend/src/shared/ui/YesfiBrandMark.tsx
 */

/** Radius of the filled disc in source art coordinates. */
export const YESFI_MARK_RADIUS = 60.6226

/** Center of the filled disc in source art coordinates (= radius for symmetry). */
export const YESFI_MARK_CENTER = YESFI_MARK_RADIUS

/** First concentric ring just outside the filled disc. */
export const YESFI_RING_NEAR_RADIUS = 82.2306

/** Second concentric ring outside the first. */
export const YESFI_RING_FAR_RADIUS = 95.4355

/** Symmetric viewBox origin that includes both outer rings. */
export const YESFI_MARK_VIEW_ORIGIN = YESFI_MARK_CENTER - YESFI_RING_FAR_RADIUS

/** Symmetric viewBox size that includes both outer rings. */
export const YESFI_MARK_VIEW_SIZE = YESFI_RING_FAR_RADIUS * 2

/** Filled check body (maps to checkPrimary color). */
export const YESFI_CHECK_PATH_PRIMARY =
  'M43.4254 55.6747L53.9 66.2114L79.3523 40.575C83.3464 36.5521 89.8535 36.5545 93.8446 40.5806L94.4518 41.1931C98.3974 45.1733 98.3957 51.5904 94.448 55.5686L61.1434 89.1302C57.1517 93.1526 50.6475 93.1534 46.6549 89.1319L28.3331 70.6776C24.3838 66.6998 24.3813 60.2813 28.3276 56.3004L28.9378 55.6849C32.927 51.6607 39.4305 51.6561 43.4254 55.6747Z'

/** Highlight facet on the check (maps to checkHighlight color). */
export const YESFI_CHECK_PATH_HIGHLIGHT =
  'M79.3517 40.5753C83.3456 36.5524 89.8528 36.5545 93.8438 40.5802L94.4513 41.1935C98.3968 45.1737 98.395 51.5903 94.4474 55.5685L73.3604 76.8165C69.4318 78.0149 64.9879 77.0631 61.881 73.9561L54.0177 66.0919L79.3517 40.5753Z'

/** Clip rectangle that isolates the check mark area. */
export const YESFI_CHECK_CLIP = {
  width: 80.3801,
  height: 63.1558,
  x: 21.1983,
  y: 33.2737,
} as const

/** Ring stroke width from Figma hero export. */
export const YESFI_RING_STROKE_WIDTH = 1.20045
